import { useEffect } from 'react';
import { useAppRouter } from '../useAppRouter';
import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';
import { useGrowthBookFlag } from '../useGrowthBookFlag/useGrowthBookFlag';

/** Present on call (and related) routes when suppression should hide the Statuspage iframe. */
const BODY_CLASS_STATUSPAGE_SUPPRESSION_IN_CALL =
  'statuspage-suppression-in-call';

const normalizePathname = (pathname: string | undefined): string =>
  (pathname ?? '').replace(/\/$/, '') || '';

const isStatuspageSuppressedRoute = (pathname: string | undefined): boolean => {
  const { paths } = getPublicRuntimeConfig();
  const normalized = normalizePathname(pathname);
  return (
    normalized === normalizePathname(paths.call) ||
    normalized === normalizePathname(paths.callHold) ||
    normalized === normalizePathname(paths.testCall)
  );
};

/**
 * When the GrowthBook flag `bug_prod_7109_statuspage_toast_only_dashboard` is on, toggles
 * body classes so GlobalStyles can hide the Statuspage embed iframe on in-call routes only.
 */
export function useStatuspageIncidentEmbedSuppression(): void {
  const router = useAppRouter();
  const isFlagOn =
    useGrowthBookFlag('bug_prod_7109_statuspage_toast_only_dashboard') === true;

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const { body } = document;
    const shouldSuppress =
      isFlagOn && isStatuspageSuppressedRoute(router.pathname);

    body.classList.toggle(
      BODY_CLASS_STATUSPAGE_SUPPRESSION_IN_CALL,
      shouldSuppress,
    );

    return () => {
      body.classList.remove(BODY_CLASS_STATUSPAGE_SUPPRESSION_IN_CALL);
    };
  }, [isFlagOn, router.pathname]);
}
